import React from 'react';
import PieChart from './PieChart';
import { useMobile } from '../../../contexts/MobileContext';
import { useTheme } from '../../../contexts/ThemeContext';
import { getChartTheme } from '../charting/chartTheme';

const FALLBACK_PIE_VALUES = { human: 80, bot: 20 };

const PieGraph = ({specs}) => {
  const { isMobile } = useMobile();
  const { isDarkMode } = useTheme();
  const theme = getChartTheme(isDarkMode);
  const {values} = specs;

  const [previousHumanClicks, previousBotClicks] = values.old;

  const previousTotalClicks = previousHumanClicks + previousBotClicks;
  let previousPercentage;

  if (previousHumanClicks === 0 && previousTotalClicks === 0) {
    previousPercentage = null;
  }
  else {
    previousPercentage = 100 * previousHumanClicks / previousTotalClicks;
  }
  const hasPreviousData = previousPercentage !== null;

  const currentBotClicks = values.bot.reduce((a, b) => a + b, 0);
  const currentHumanClicks = values.human.reduce((a, b) => a + b, 0);
  const currentTotalClicks = currentHumanClicks + currentBotClicks;
  let currentPercentage;

  if (currentHumanClicks === 0 && currentTotalClicks === 0) {
    currentPercentage = null;
  }
  else {
    currentPercentage = 100 * currentHumanClicks / currentTotalClicks;
  }
  const hasCurrentData = currentPercentage !== null;

  const sizing = isMobile
    ? { inner1: 68, outer1: 132, inner2: 90, outer2: 116 }
    : { inner1: 84, outer1: 156, inner2: 106, outer2: 134 };

  const getPieData = (percentage, hasData) => {
    const humanValue = hasData ? percentage.toFixed(2) : FALLBACK_PIE_VALUES.human;
    const botValue = hasData ? (100 - percentage).toFixed(2) : FALLBACK_PIE_VALUES.bot;

    return [
      {
        label: 'Human Traffic',
        value: humanValue,
        innerRadius: sizing.inner1,
        outerRadius: sizing.outer1,
        color: theme.primaryDark,
      },
      {
        label: 'Bot Traffic',
        value: botValue,
        innerRadius: sizing.inner2,
        outerRadius: sizing.outer2,
        color: theme.bot,
      },
    ];
  };

  const renderPieCell = (label, percentage, hasData) => (
    <div className="pie-graph__cell">
      <PieChart
        isDarkMode={isDarkMode}
        text={hasData ? label : 'NO DATA'}
        disabled={!hasData}
        data={getPieData(percentage, hasData)}
      />
    </div>
  );

  return (
    <div className="pie-graph">
      <div className="pie-graph__grid">
        {renderPieCell('PREVIOUS\nPERIOD', previousPercentage, hasPreviousData)}
        {renderPieCell('CURRENT\nPERIOD', currentPercentage, hasCurrentData)}
      </div>
    </div>
  );
}

export default PieGraph;
